class FindMarker {
    constructor() {
        this.setup();
    }
    setup() {
        const attrName = 'data-map-find-marker';

        document.querySelectorAll('[' + attrName + ']').forEach((element) => {
			element.addEventListener('click', (e) => {
				e.preventDefault();

                let marker = e.currentTarget.getAttribute(attrName);

                // Locate marker on the map
                window.mapMarkerClick(marker, true);

                // Zoom in to avoid clusters
                window.map.zoom(17);
			});
		});
    }
}

export default new FindMarker();
